/**
 * @generated SignedSource<<87994347e55657a50a8d6fbf72f56ce2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type confluenceTemplatesUnifiedContentfulRelayPageQuery$variables = {
  categoryUrlSlugs: ReadonlyArray<string>;
  isSearch?: boolean | null | undefined;
  limit: number;
  locale: string;
  partnerTemplatesDataUrlSlugs: ReadonlyArray<string>;
  skip: number;
  templateIds: ReadonlyArray<string>;
  urlSlugs: ReadonlyArray<string>;
};
export type confluenceTemplatesUnifiedContentfulRelayPageQuery$data = {
  readonly categories: {
    readonly items: ReadonlyArray<{
      readonly categoryCollection: {
        readonly items: ReadonlyArray<{
          readonly categoryNameExternal: string | null | undefined;
          readonly experiment: boolean | null | undefined;
          readonly linkedFrom: {
            readonly productTemplateCollection: {
              readonly total: number;
            } | null | undefined;
          } | null | undefined;
          readonly shortDescriptionOneLiner: string | null | undefined;
          readonly sys: {
            readonly id: string;
          };
          readonly urlSlug: string | null | undefined;
        } | null | undefined>;
        readonly total: number;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly collections: {
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"collectionCardCarouselContentfulRelayFragment">;
    } | null | undefined>;
  } | null | undefined;
  readonly partnerTemplates: {
    readonly items: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardCarouselContentfulRelayFragment">;
    } | null | undefined>;
  } | null | undefined;
  readonly preloadedSearchResults?: {
    readonly " $fragmentSpreads": FragmentRefs<"templatePaginatedSearchResultsContentfulRelayRefetchableFragment">;
  } | null | undefined;
};
export type confluenceTemplatesUnifiedContentfulRelayPageQuery = {
  response: confluenceTemplatesUnifiedContentfulRelayPageQuery$data;
  variables: confluenceTemplatesUnifiedContentfulRelayPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryUrlSlugs"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSearch"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "partnerTemplatesDataUrlSlugs"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateIds"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlugs"
},
v8 = {
  "kind": "Variable",
  "name": "locale",
  "variableName": "locale"
},
v9 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 50
  },
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v14 = {
  "alias": "categories",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 400
    },
    (v8/*: any*/)
  ],
  "concreteType": "ProductTemplateCollection",
  "kind": "LinkedField",
  "name": "productTemplateCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplate",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "limit",
              "value": 10
            }
          ],
          "concreteType": "ProductTemplateCategoryCollection",
          "kind": "LinkedField",
          "name": "categoryCollection",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TaxonomyTemplateCategory",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v11/*: any*/),
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryNameExternal",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shortDescriptionOneLiner",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "experiment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "allowedLocales",
                      "value": [
                        "en-US",
                        "es",
                        "ja-JP",
                        "pt-BR",
                        "fr-FR",
                        "de-DE",
                        "nl-NL",
                        "it-IT",
                        "ko-KR",
                        "pl-PL",
                        "ru-RU",
                        "zh-CN"
                      ]
                    }
                  ],
                  "concreteType": "TaxonomyTemplateCategoryLinkingCollections",
                  "kind": "LinkedField",
                  "name": "linkedFrom",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": (v13/*: any*/),
                      "concreteType": "ProductTemplateCollection",
                      "kind": "LinkedField",
                      "name": "productTemplateCollection",
                      "plural": false,
                      "selections": [
                        (v10/*: any*/)
                      ],
                      "storageKey": "productTemplateCollection(limit:1)"
                    }
                  ],
                  "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "categoryCollection(limit:10)"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  (v8/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "urlSlug_in",
        "variableName": "partnerTemplatesDataUrlSlugs"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v16 = {
  "kind": "Variable",
  "name": "limit",
  "variableName": "limit"
},
v17 = {
  "kind": "Variable",
  "name": "skip",
  "variableName": "skip"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateNameExternal",
  "storageKey": null
},
v20 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organizationNameExternal",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "confluenceTemplatesUnifiedContentfulRelayPageQuery",
    "selections": [
      {
        "alias": "collections",
        "args": (v9/*: any*/),
        "concreteType": "TemplateCollectionCollection",
        "kind": "LinkedField",
        "name": "templateCollectionCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TemplateCollection",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "collectionCardCarouselContentfulRelayFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v14/*: any*/),
      {
        "alias": "partnerTemplates",
        "args": (v15/*: any*/),
        "concreteType": "ProductTemplateCollection",
        "kind": "LinkedField",
        "name": "productTemplateCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplate",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "partnerTemplateCardCarouselContentfulRelayFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "categoryUrlSlugs",
                      "variableName": "categoryUrlSlugs"
                    },
                    (v16/*: any*/),
                    (v8/*: any*/),
                    (v17/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "templateIds",
                      "variableName": "templateIds"
                    },
                    {
                      "kind": "Variable",
                      "name": "urlSlugs",
                      "variableName": "urlSlugs"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment"
                }
              ],
              "type": "Query",
              "abstractKey": null
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "preloadedSearchResults"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "confluenceTemplatesUnifiedContentfulRelayPageQuery",
    "selections": [
      {
        "alias": "collections",
        "args": (v9/*: any*/),
        "concreteType": "TemplateCollectionCollection",
        "kind": "LinkedField",
        "name": "templateCollectionCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TemplateCollection",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collectionNameExternal",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "collectionIcon",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CollectionGuide",
                "kind": "LinkedField",
                "name": "howToUseThisCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CollectionGuideCollectionStepsCollection",
                    "kind": "LinkedField",
                    "name": "collectionStepsCollection",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v14/*: any*/),
      {
        "alias": "partnerTemplates",
        "args": (v15/*: any*/),
        "concreteType": "ProductTemplateCollection",
        "kind": "LinkedField",
        "name": "productTemplateCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductTemplate",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneLinerHeadline",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "templates",
            "args": [
              (v16/*: any*/),
              (v8/*: any*/),
              (v17/*: any*/),
              {
                "fields": [
                  {
                    "items": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "urlSlug_in",
                            "variableName": "urlSlugs"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "OR.0"
                      },
                      {
                        "fields": [
                          {
                            "fields": [
                              {
                                "kind": "Variable",
                                "name": "id_in",
                                "variableName": "templateIds"
                              }
                            ],
                            "kind": "ObjectValue",
                            "name": "sys"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "OR.1"
                      },
                      {
                        "fields": [
                          {
                            "fields": [
                              {
                                "kind": "Variable",
                                "name": "urlSlug_in",
                                "variableName": "categoryUrlSlugs"
                              }
                            ],
                            "kind": "ObjectValue",
                            "name": "category"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "OR.2"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "OR"
                  }
                ],
                "kind": "ObjectValue",
                "name": "where"
              }
            ],
            "concreteType": "ProductTemplateCollection",
            "kind": "LinkedField",
            "name": "productTemplateCollection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductTemplate",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": (v13/*: any*/),
                    "concreteType": "ProductTemplateProductCollection",
                    "kind": "LinkedField",
                    "name": "productCollection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductListing",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductName",
                            "kind": "LinkedField",
                            "name": "productNameReference",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productNameId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "productCollection(limit:1)"
                  },
                  (v19/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pluginModuleKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previewBlurb",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductTemplateTemplateTypeCollection",
                    "kind": "LinkedField",
                    "name": "templateTypeCollection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TaxonomyTemplateType",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateTypeNameExternal",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "contributor",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyNameInternal",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Author",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v20/*: any*/),
                        "type": "CompanyNameInternal",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f7e0983cf6c22e16df9a03db88467a5a",
    "id": null,
    "metadata": {},
    "name": "confluenceTemplatesUnifiedContentfulRelayPageQuery",
    "operationKind": "query",
    "text": "query confluenceTemplatesUnifiedContentfulRelayPageQuery(\n  $locale: String!\n  $partnerTemplatesDataUrlSlugs: [String!]!\n  $urlSlugs: [String!]!\n  $templateIds: [String!]!\n  $categoryUrlSlugs: [String!]!\n  $limit: Int!\n  $skip: Int!\n  $isSearch: Boolean = false\n) {\n  collections: templateCollectionCollection(limit: 50, locale: $locale) {\n    items {\n      ...collectionCardCarouselContentfulRelayFragment\n    }\n  }\n  categories: productTemplateCollection(limit: 400, locale: $locale) {\n    items {\n      categoryCollection(limit: 10) {\n        total\n        items {\n          sys {\n            id\n          }\n          urlSlug\n          categoryNameExternal\n          shortDescriptionOneLiner\n          experiment\n          linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n            productTemplateCollection(limit: 1) {\n              total\n            }\n          }\n        }\n      }\n    }\n  }\n  partnerTemplates: productTemplateCollection(locale: $locale, where: {urlSlug_in: $partnerTemplatesDataUrlSlugs}) {\n    items {\n      ...partnerTemplateCardCarouselContentfulRelayFragment\n    }\n  }\n  ...templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P @skip(if: $isSearch)\n}\n\nfragment collectionCardCarouselContentfulRelayFragment on TemplateCollection {\n  sys {\n    id\n  }\n  ...collectionCardContentfulRelayFragment\n}\n\nfragment collectionCardContentfulRelayFragment on TemplateCollection {\n  sys {\n    id\n  }\n  collectionNameExternal\n  urlSlug\n  collectionIcon {\n    url\n  }\n  howToUseThisCollection {\n    collectionStepsCollection {\n      total\n      __typename\n    }\n  }\n}\n\nfragment partnerTemplateCardCarouselContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  urlSlug\n  ...partnerTemplateCardContentfulRelayFragment\n}\n\nfragment partnerTemplateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  urlSlug\n  templateNameExternal\n  oneLinerHeadline\n}\n\nfragment templateCardContentfulRelayFragment on ProductTemplate {\n  sys {\n    id\n  }\n  templateNameExternal\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateTypeCollection {\n    items {\n      sys {\n        id\n      }\n      templateTypeNameExternal\n    }\n  }\n  contributor {\n    __typename\n    ... on Author {\n      organization {\n        organizationNameExternal\n      }\n    }\n    ... on CompanyNameInternal {\n      organizationNameExternal\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsContentfulRelayRefetchableFragment_3v162P on Query {\n  templates: productTemplateCollection(limit: $limit, skip: $skip, locale: $locale, where: {OR: [{urlSlug_in: $urlSlugs}, {sys: {id_in: $templateIds}}, {category: {urlSlug_in: $categoryUrlSlugs}}]}) {\n    items {\n      sys {\n        id\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      templateNameExternal\n      urlSlug\n      ...templateCardContentfulRelayFragment\n    }\n    total\n  }\n}\n"
  }
};
})();

(node as any).hash = "07a7f8b979e3e44fe68d35fcfbf01207";

export default node;
